type DottedCircleProps = React.SVGProps<SVGSVGElement> & { size?: string };

export const DottedCircle = ({ size = "20", ...props }: DottedCircleProps) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <circle
        cx="10"
        cy="10"
        r="9.3"
        fill="#F3F3F5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeDasharray="4 4"
      />
    </svg>
  );
};
